export default __webpack_public_path__ + "static/media/city-hall-elearning.598b5488.svg";